export default __webpack_public_path__ + "static/media/phosphoricons-clock-clockwise.129213fe.svg";